import React, { useEffect } from "react"
import { Link } from "react-router-dom"

export const UnderConstruction = () => {

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <header className="ms-hero-page-override ms-hero-img-sibeken ms-bg-fixed no-mt pb-4" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
                <div className="container">
                    <div className="row no-shadow justify-content-center">
                        <div className="col-lg-8 text-center">
                            <div className="card card-banner animated zoomInUp animation-delay-3 p-5">
                                <div className="card-body">
                                    <div className="mb-4">
                                        <i className="zmdi zmdi-settings zmdi-hc-spin color-success" style={{ fontSize: '5rem' }}></i>
                                    </div>
                                    <h1 className='color-black font-bold lh-125 mb-3' style={{ fontSize: '2.3rem' }}>MOHON MAAF, HALAMAN DALAM TAHAP PENGEMBANGAN</h1>
                                    <h3 className='color-dark lh-125 mb-4'>
                                        Layanan atau fitur yang Anda akses saat ini sedang dalam proses penyiapan dan integrasi sistem oleh tim teknis. Silakan kembali ke beranda untuk mengakses layanan publik lainnya.
                                    </h3>
                                    <div className="lh-125">
                                        <Link to={'/'} className="btn btn-raised btn-primary br-2 px-4 py-2">
                                            <i className="zmdi zmdi-home mr-2"></i> Kembali ke Beranda
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}